// TagsInput.jsx
import React, { useState } from "react";
import { useEffect } from "react";
let uniqueArr=[];

const EmailInput = ({selectedEmails,setAddEmails,setErrors}) => {
    const [emails, setEmails] = useState([]);
    
    useEffect(()=>{
        uniqueArr = [...new Set(selectedEmails.map(item => item))];
        setEmails(uniqueArr.filter(item => item))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectedEmails])

    const addTags = event => {
        event.preventDefault();
        if (event.key === "Enter" && event.target.value !== "") {
            
            
            if (/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(event.target.value))
            {
                setEmails([...emails, event.target.value]);
                setAddEmails([...selectedEmails, event.target.value]);
                event.target.value = "";
                setErrors((prev)=>{
                    return {
                        ...prev,
                        emailValid:false
                    }
                })
            }else{
                setErrors((prev)=>{
                    return {
                        ...prev,
                        emailValid:true
                    }
                })
            }
            
        }
    };

    const removeTags = index => {
        setEmails([...emails.filter(tag => emails.indexOf(tag) !== index)]);
        setAddEmails([...selectedEmails.filter(tag => selectedEmails.indexOf(tag) !== index)]);
    };

    const handleEmails = (event) =>{
        event.target.value = ''
        setErrors((prev)=>{
            return {
                ...prev,
                emailValid:false
            }
        })
    }

    return (
        <div className="tags-input p-0">
            <ul id="tags">
                {emails.map((tag, index) => (
                    
                    <li key={index} className="tag">
                        <span className="tag-tile">{tag}</span>
                        <i 
                            className="tag-close-icon"
                            onClick={() => removeTags(index)}
                            style={{display: "inline-block"}}
                        >x</i>
                    </li>
                ))}
            </ul>
            <input
                type="text"
                placeholder="Press enter to add emails"
                onKeyUp={event => addTags(event)}
                onBlur = {handleEmails}
            />
        </div>
    );
};
export default EmailInput;